import script from "./OCriarAtributo.vue?vue&type=script&lang=ts&setup=true"
export * from "./OCriarAtributo.vue?vue&type=script&lang=ts&setup=true"

import "./OCriarAtributo.vue?vue&type=style&index=0&id=5c3dc8c1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c3dc8c1"]])

export default __exports__